var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-flow-session-message',{attrs:{"icon":"status_failed","icon-variant":"danger","title":_vm.s__('DuoAgentPlatform|Session failed'),"timestamp":_vm.updatedAt,"data-testid":"agent-flow-failed-state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }